export const THEMES = [
    'green_phosphor',
    'amber_phosphor',
    'commodore',
    'atari',
    'spectrum',
    'amstrad',
    'amiga',
    'vu_meter',
    'brushed_aluminum',
    'darkroom',
    'chrome_leather',
    'reel_to_reel',
    'vinyl_groove',
    'tube_glow',
    'midnight_dial',
    'guilloche',
    'kodachrome',
    'film_noir',
    'cyanotype',
    'patina',
    'rose_gold',
    'lume',
    'modern_dark',
    'modern_light',
    'vivid',
];
export const THEME_DEFINITIONS = {
    green_phosphor: {
        name: 'green_phosphor',
        label: 'Green Phosphor (P1)',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#050505',
            '--bg-secondary': 'rgba(0,255,65,0.08)',
            '--bg-tertiary': 'rgba(0,255,65,0.12)',
            '--bg-hover': 'rgba(0,255,65,0.16)',
            '--bg-solid': '#0a1a0a',
            '--text-primary': '#00ff41',
            '--text-secondary': '#00cc33',
            '--text-muted': '#007722',
            '--text-on-accent': '#000000',
            '--accent': '#00ff41',
            '--accent-hover': '#33ff66',
            '--accent-glow': 'rgba(0,255,65,0.20)',
            '--accent-subtle': 'rgba(0,255,65,0.10)',
            '--error': '#ff3333',
            '--error-bg': 'rgba(255,51,51,0.10)',
            '--success': '#00ff41',
            '--success-bg': 'rgba(0,255,65,0.10)',
            '--warning': '#ffcc00',
            '--warning-bg': 'rgba(255,204,0,0.10)',
            '--border': 'rgba(0,255,65,0.10)',
            '--border-hover': 'rgba(0,255,65,0.20)',
            '--border-accent': 'rgba(0,255,65,0.35)',
            '--glass-bg': 'rgba(0,255,65,0.04)',
            '--glass-border': 'rgba(0,255,65,0.10)',
            '--shadow-glow': '0 0 24px rgba(0,255,65,0.15)',
            '--header-bg': 'rgba(5,5,5,0.90)',
            '--sidebar-bg': 'rgba(5,5,5,0.70)',
            '--overlay-bg': 'rgba(5,5,5,0.95)',
            '--scrollbar-thumb': 'rgba(0,255,65,0.12)',
            '--scrollbar-thumb-hover': 'rgba(0,255,65,0.25)',
        },
    },
    amber_phosphor: {
        name: 'amber_phosphor',
        label: 'Amber Phosphor (P3)',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#050500',
            '--bg-secondary': 'rgba(255,176,0,0.08)',
            '--bg-tertiary': 'rgba(255,176,0,0.12)',
            '--bg-hover': 'rgba(255,176,0,0.16)',
            '--bg-solid': '#1a1405',
            '--text-primary': '#FFB000',
            '--text-secondary': '#CC8C00',
            '--text-muted': '#806000',
            '--text-on-accent': '#000000',
            '--accent': '#FFB000',
            '--accent-hover': '#FFC933',
            '--accent-glow': 'rgba(255,176,0,0.20)',
            '--accent-subtle': 'rgba(255,176,0,0.10)',
            '--error': '#ff4444',
            '--error-bg': 'rgba(255,68,68,0.10)',
            '--success': '#FFB000',
            '--success-bg': 'rgba(255,176,0,0.10)',
            '--warning': '#ff6600',
            '--warning-bg': 'rgba(255,102,0,0.10)',
            '--border': 'rgba(255,176,0,0.10)',
            '--border-hover': 'rgba(255,176,0,0.20)',
            '--border-accent': 'rgba(255,176,0,0.35)',
            '--glass-bg': 'rgba(255,176,0,0.04)',
            '--glass-border': 'rgba(255,176,0,0.10)',
            '--shadow-glow': '0 0 24px rgba(255,176,0,0.15)',
            '--header-bg': 'rgba(5,5,0,0.90)',
            '--sidebar-bg': 'rgba(5,5,0,0.70)',
            '--overlay-bg': 'rgba(5,5,0,0.95)',
            '--scrollbar-thumb': 'rgba(255,176,0,0.12)',
            '--scrollbar-thumb-hover': 'rgba(255,176,0,0.25)',
        },
    },
    commodore: {
        name: 'commodore',
        label: 'Commodore 64',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#4040e0',
            '--bg-secondary': 'rgba(160,160,255,0.12)',
            '--bg-tertiary': 'rgba(160,160,255,0.18)',
            '--bg-hover': 'rgba(160,160,255,0.22)',
            '--bg-solid': '#3838cc',
            '--text-primary': '#E0E0FF',
            '--text-secondary': '#BBBBFF',
            '--text-muted': '#9999dd',
            '--text-on-accent': '#1a1a60',
            '--accent': '#A0A0FF',
            '--accent-hover': '#C0C0FF',
            '--accent-glow': 'rgba(160,160,255,0.25)',
            '--accent-subtle': 'rgba(160,160,255,0.12)',
            '--error': '#FF6666',
            '--error-bg': 'rgba(255,102,102,0.12)',
            '--success': '#69CF69',
            '--success-bg': 'rgba(105,207,105,0.12)',
            '--warning': '#FFCC00',
            '--warning-bg': 'rgba(255,204,0,0.12)',
            '--border': 'rgba(160,160,255,0.15)',
            '--border-hover': 'rgba(160,160,255,0.25)',
            '--border-accent': 'rgba(160,160,255,0.40)',
            '--glass-bg': 'rgba(160,160,255,0.06)',
            '--glass-border': 'rgba(160,160,255,0.12)',
            '--shadow-glow': '0 0 24px rgba(160,160,255,0.20)',
            '--header-bg': 'rgba(56,56,204,0.92)',
            '--sidebar-bg': 'rgba(56,56,204,0.75)',
            '--overlay-bg': 'rgba(56,56,204,0.95)',
            '--scrollbar-thumb': 'rgba(160,160,255,0.15)',
            '--scrollbar-thumb-hover': 'rgba(160,160,255,0.30)',
        },
    },
    atari: {
        name: 'atari',
        label: 'Atari 800XL',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#000000',
            '--bg-secondary': 'rgba(255,255,255,0.07)',
            '--bg-tertiary': 'rgba(255,255,255,0.11)',
            '--bg-hover': 'rgba(255,255,255,0.15)',
            '--bg-solid': '#1A1008',
            '--text-primary': '#E0E0E0',
            '--text-secondary': '#AAAAAA',
            '--text-muted': '#666666',
            '--text-on-accent': '#000000',
            '--accent': '#FF6600',
            '--accent-hover': '#FF8833',
            '--accent-glow': 'rgba(255,102,0,0.20)',
            '--accent-subtle': 'rgba(255,102,0,0.10)',
            '--error': '#FF4444',
            '--error-bg': 'rgba(255,68,68,0.10)',
            '--success': '#44CC44',
            '--success-bg': 'rgba(68,204,68,0.10)',
            '--warning': '#FFAA00',
            '--warning-bg': 'rgba(255,170,0,0.10)',
            '--border': 'rgba(255,102,0,0.12)',
            '--border-hover': 'rgba(255,102,0,0.22)',
            '--border-accent': 'rgba(255,102,0,0.38)',
            '--glass-bg': 'rgba(255,255,255,0.05)',
            '--glass-border': 'rgba(255,255,255,0.10)',
            '--shadow-glow': '0 0 24px rgba(255,102,0,0.15)',
            '--header-bg': 'rgba(0,0,0,0.92)',
            '--sidebar-bg': 'rgba(0,0,0,0.75)',
            '--overlay-bg': 'rgba(0,0,0,0.95)',
            '--scrollbar-thumb': 'rgba(255,102,0,0.12)',
            '--scrollbar-thumb-hover': 'rgba(255,102,0,0.25)',
        },
    },
    spectrum: {
        name: 'spectrum',
        label: 'ZX Spectrum',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#D7D7D7',
            '--bg-secondary': 'rgba(0,0,0,0.06)',
            '--bg-tertiary': 'rgba(0,0,0,0.10)',
            '--bg-hover': 'rgba(0,0,0,0.14)',
            '--bg-solid': '#C8C8C8',
            '--text-primary': '#000000',
            '--text-secondary': '#333333',
            '--text-muted': '#777777',
            '--text-on-accent': '#FFFFFF',
            '--accent': '#CC0000',
            '--accent-hover': '#FF0000',
            '--accent-glow': 'rgba(204,0,0,0.15)',
            '--accent-subtle': 'rgba(204,0,0,0.10)',
            '--error': '#CC0000',
            '--error-bg': 'rgba(204,0,0,0.10)',
            '--success': '#00AA00',
            '--success-bg': 'rgba(0,170,0,0.10)',
            '--warning': '#CC8800',
            '--warning-bg': 'rgba(204,136,0,0.12)',
            '--border': 'rgba(0,0,0,0.15)',
            '--border-hover': 'rgba(0,0,0,0.25)',
            '--border-accent': 'rgba(204,0,0,0.35)',
            '--glass-bg': 'rgba(0,0,0,0.04)',
            '--glass-border': 'rgba(0,0,0,0.12)',
            '--shadow-glow': '0 0 24px rgba(204,0,0,0.12)',
            '--header-bg': 'rgba(200,200,200,0.95)',
            '--sidebar-bg': 'rgba(200,200,200,0.85)',
            '--overlay-bg': 'rgba(200,200,200,0.97)',
            '--scrollbar-thumb': 'rgba(0,0,0,0.15)',
            '--scrollbar-thumb-hover': 'rgba(0,0,0,0.30)',
        },
    },
    amstrad: {
        name: 'amstrad',
        label: 'Amstrad CPC 464',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#000080',
            '--bg-secondary': 'rgba(255,255,0,0.06)',
            '--bg-tertiary': 'rgba(255,255,0,0.10)',
            '--bg-hover': 'rgba(255,255,0,0.14)',
            '--bg-solid': '#000066',
            '--text-primary': '#FFFF00',
            '--text-secondary': '#CCCC00',
            '--text-muted': '#808000',
            '--text-on-accent': '#000080',
            '--accent': '#FFFF00',
            '--accent-hover': '#FFFF66',
            '--accent-glow': 'rgba(255,255,0,0.20)',
            '--accent-subtle': 'rgba(255,255,0,0.10)',
            '--error': '#FF4444',
            '--error-bg': 'rgba(255,68,68,0.12)',
            '--success': '#44FF44',
            '--success-bg': 'rgba(68,255,68,0.12)',
            '--warning': '#FF8800',
            '--warning-bg': 'rgba(255,136,0,0.12)',
            '--border': 'rgba(255,255,0,0.10)',
            '--border-hover': 'rgba(255,255,0,0.20)',
            '--border-accent': 'rgba(255,255,0,0.35)',
            '--glass-bg': 'rgba(255,255,0,0.04)',
            '--glass-border': 'rgba(255,255,0,0.10)',
            '--shadow-glow': '0 0 24px rgba(255,255,0,0.15)',
            '--header-bg': 'rgba(0,0,102,0.92)',
            '--sidebar-bg': 'rgba(0,0,102,0.75)',
            '--overlay-bg': 'rgba(0,0,102,0.95)',
            '--scrollbar-thumb': 'rgba(255,255,0,0.12)',
            '--scrollbar-thumb-hover': 'rgba(255,255,0,0.25)',
        },
    },
    amiga: {
        name: 'amiga',
        label: 'Amiga Workbench',
        group: 'Retro Computers',
        colors: {
            '--bg-primary': '#0055AA',
            '--bg-secondary': 'rgba(255,255,255,0.12)',
            '--bg-tertiary': 'rgba(255,255,255,0.18)',
            '--bg-hover': 'rgba(255,255,255,0.22)',
            '--bg-solid': '#004499',
            '--text-primary': '#FFFFFF',
            '--text-secondary': '#DDDDDD',
            '--text-muted': '#88AACC',
            '--text-on-accent': '#000000',
            '--accent': '#FF8800',
            '--accent-hover': '#FFAA33',
            '--accent-glow': 'rgba(255,136,0,0.20)',
            '--accent-subtle': 'rgba(255,136,0,0.10)',
            '--error': '#FF4444',
            '--error-bg': 'rgba(255,68,68,0.12)',
            '--success': '#44CC44',
            '--success-bg': 'rgba(68,204,68,0.12)',
            '--warning': '#FFCC00',
            '--warning-bg': 'rgba(255,204,0,0.12)',
            '--border': 'rgba(255,136,0,0.12)',
            '--border-hover': 'rgba(255,136,0,0.22)',
            '--border-accent': 'rgba(255,136,0,0.38)',
            '--glass-bg': 'rgba(255,255,255,0.08)',
            '--glass-border': 'rgba(255,255,255,0.14)',
            '--shadow-glow': '0 0 24px rgba(255,136,0,0.15)',
            '--header-bg': 'rgba(0,68,153,0.92)',
            '--sidebar-bg': 'rgba(0,68,153,0.75)',
            '--overlay-bg': 'rgba(0,68,153,0.95)',
            '--scrollbar-thumb': 'rgba(255,136,0,0.12)',
            '--scrollbar-thumb-hover': 'rgba(255,136,0,0.25)',
        },
    },
    vu_meter: {
        name: 'vu_meter',
        label: 'VU Meter',
        group: 'Retro Audio / Hi-Fi',
        colors: {
            '--bg-primary': '#1a0e00',
            '--bg-secondary': 'rgba(255,160,40,0.08)',
            '--bg-tertiary': 'rgba(255,160,40,0.12)',
            '--bg-hover': 'rgba(255,160,40,0.16)',
            '--bg-solid': '#1f1200',
            '--text-primary': '#FFD49A',
            '--text-secondary': '#CC9960',
            '--text-muted': '#806030',
            '--text-on-accent': '#000000',
            '--accent': '#FFA028',
            '--accent-hover': '#FFB850',
            '--accent-glow': 'rgba(255,160,40,0.25)',
            '--accent-subtle': 'rgba(255,160,40,0.10)',
            '--error': '#FF4444',
            '--error-bg': 'rgba(255,68,68,0.10)',
            '--success': '#44CC44',
            '--success-bg': 'rgba(68,204,68,0.10)',
            '--warning': '#FFAA00',
            '--warning-bg': 'rgba(255,170,0,0.10)',
            '--border': 'rgba(255,160,40,0.12)',
            '--border-hover': 'rgba(255,160,40,0.22)',
            '--border-accent': 'rgba(255,160,40,0.38)',
            '--glass-bg': 'rgba(255,160,40,0.04)',
            '--glass-border': 'rgba(255,160,40,0.10)',
            '--shadow-glow': '0 0 24px rgba(255,160,40,0.18)',
            '--header-bg': 'rgba(26,14,0,0.92)',
            '--sidebar-bg': 'rgba(26,14,0,0.75)',
            '--overlay-bg': 'rgba(26,14,0,0.95)',
            '--scrollbar-thumb': 'rgba(255,160,40,0.12)',
            '--scrollbar-thumb-hover': 'rgba(255,160,40,0.25)',
        },
    },
    reel_to_reel: {
        name: 'reel_to_reel',
        label: 'Reel-to-Reel',
        group: 'Retro Audio / Hi-Fi',
        colors: {
            '--bg-primary': '#1a1008',
            '--bg-secondary': 'rgba(180,120,60,0.08)',
            '--bg-tertiary': 'rgba(180,120,60,0.12)',
            '--bg-hover': 'rgba(180,120,60,0.16)',
            '--bg-solid': '#201408',
            '--text-primary': '#e0c8a0',
            '--text-secondary': '#b89868',
            '--text-muted': '#7a6040',
            '--text-on-accent': '#1a1008',
            '--accent': '#c87830',
            '--accent-hover': '#e09040',
            '--accent-glow': 'rgba(200,120,48,0.22)',
            '--accent-subtle': 'rgba(200,120,48,0.10)',
            '--error': '#e05040',
            '--error-bg': 'rgba(224,80,64,0.10)',
            '--success': '#60a860',
            '--success-bg': 'rgba(96,168,96,0.10)',
            '--warning': '#d0a020',
            '--warning-bg': 'rgba(208,160,32,0.10)',
            '--border': 'rgba(180,120,60,0.12)',
            '--border-hover': 'rgba(180,120,60,0.22)',
            '--border-accent': 'rgba(200,120,48,0.38)',
            '--glass-bg': 'rgba(180,120,60,0.04)',
            '--glass-border': 'rgba(180,120,60,0.10)',
            '--shadow-glow': '0 0 24px rgba(200,120,48,0.15)',
            '--header-bg': 'rgba(26,16,8,0.92)',
            '--sidebar-bg': 'rgba(26,16,8,0.75)',
            '--overlay-bg': 'rgba(26,16,8,0.95)',
            '--scrollbar-thumb': 'rgba(180,120,60,0.12)',
            '--scrollbar-thumb-hover': 'rgba(180,120,60,0.25)',
        },
    },
    vinyl_groove: {
        name: 'vinyl_groove',
        label: 'Vinyl Groove',
        group: 'Retro Audio / Hi-Fi',
        colors: {
            '--bg-primary': '#0c0812',
            '--bg-secondary': 'rgba(120,60,180,0.08)',
            '--bg-tertiary': 'rgba(120,60,180,0.12)',
            '--bg-hover': 'rgba(120,60,180,0.16)',
            '--bg-solid': '#120c1a',
            '--text-primary': '#d8c8f0',
            '--text-secondary': '#a088c8',
            '--text-muted': '#685090',
            '--text-on-accent': '#0c0812',
            '--accent': '#a050e0',
            '--accent-hover': '#c070ff',
            '--accent-glow': 'rgba(160,80,224,0.22)',
            '--accent-subtle': 'rgba(160,80,224,0.10)',
            '--error': '#e05050',
            '--error-bg': 'rgba(224,80,80,0.10)',
            '--success': '#50c070',
            '--success-bg': 'rgba(80,192,112,0.10)',
            '--warning': '#e0a030',
            '--warning-bg': 'rgba(224,160,48,0.10)',
            '--border': 'rgba(120,60,180,0.12)',
            '--border-hover': 'rgba(120,60,180,0.22)',
            '--border-accent': 'rgba(160,80,224,0.38)',
            '--glass-bg': 'rgba(120,60,180,0.04)',
            '--glass-border': 'rgba(120,60,180,0.10)',
            '--shadow-glow': '0 0 24px rgba(160,80,224,0.18)',
            '--header-bg': 'rgba(12,8,18,0.92)',
            '--sidebar-bg': 'rgba(12,8,18,0.75)',
            '--overlay-bg': 'rgba(12,8,18,0.95)',
            '--scrollbar-thumb': 'rgba(120,60,180,0.12)',
            '--scrollbar-thumb-hover': 'rgba(120,60,180,0.25)',
        },
    },
    tube_glow: {
        name: 'tube_glow',
        label: 'Tube Glow',
        group: 'Retro Audio / Hi-Fi',
        colors: {
            '--bg-primary': '#100800',
            '--bg-secondary': 'rgba(255,140,30,0.08)',
            '--bg-tertiary': 'rgba(255,140,30,0.12)',
            '--bg-hover': 'rgba(255,140,30,0.16)',
            '--bg-solid': '#180c00',
            '--text-primary': '#ffd8a0',
            '--text-secondary': '#c8a060',
            '--text-muted': '#886830',
            '--text-on-accent': '#100800',
            '--accent': '#ff8c1e',
            '--accent-hover': '#ffa848',
            '--accent-glow': 'rgba(255,140,30,0.28)',
            '--accent-subtle': 'rgba(255,140,30,0.10)',
            '--error': '#e04040',
            '--error-bg': 'rgba(224,64,64,0.10)',
            '--success': '#50b050',
            '--success-bg': 'rgba(80,176,80,0.10)',
            '--warning': '#e0b020',
            '--warning-bg': 'rgba(224,176,32,0.10)',
            '--border': 'rgba(255,140,30,0.12)',
            '--border-hover': 'rgba(255,140,30,0.22)',
            '--border-accent': 'rgba(255,140,30,0.38)',
            '--glass-bg': 'rgba(255,140,30,0.04)',
            '--glass-border': 'rgba(255,140,30,0.10)',
            '--shadow-glow': '0 0 24px rgba(255,140,30,0.22)',
            '--header-bg': 'rgba(16,8,0,0.92)',
            '--sidebar-bg': 'rgba(16,8,0,0.75)',
            '--overlay-bg': 'rgba(16,8,0,0.95)',
            '--scrollbar-thumb': 'rgba(255,140,30,0.12)',
            '--scrollbar-thumb-hover': 'rgba(255,140,30,0.25)',
        },
    },
    brushed_aluminum: {
        name: 'brushed_aluminum',
        label: 'Brushed Aluminum',
        group: 'Retro Audio / Hi-Fi',
        colors: {
            '--bg-primary': '#e8eaed',
            '--bg-secondary': '#f4f5f7',
            '--bg-tertiary': '#dfe1e5',
            '--bg-hover': 'rgba(100,116,139,0.10)',
            '--bg-solid': '#d3d6db',
            '--text-primary': '#1e293b',
            '--text-secondary': '#475569',
            '--text-muted': '#94a3b8',
            '--text-on-accent': '#ffffff',
            '--accent': '#64748b',
            '--accent-hover': '#475569',
            '--accent-glow': 'rgba(100,116,139,0.15)',
            '--accent-subtle': 'rgba(100,116,139,0.08)',
            '--error': '#dc2626',
            '--error-bg': 'rgba(220,38,38,0.08)',
            '--success': '#16a34a',
            '--success-bg': 'rgba(22,163,74,0.08)',
            '--warning': '#d97706',
            '--warning-bg': 'rgba(217,119,6,0.08)',
            '--border': 'rgba(0,0,0,0.10)',
            '--border-hover': 'rgba(0,0,0,0.18)',
            '--border-accent': 'rgba(100,116,139,0.35)',
            '--glass-bg': 'rgba(0,0,0,0.02)',
            '--glass-border': 'rgba(0,0,0,0.06)',
            '--shadow-glow': '0 1px 3px rgba(0,0,0,0.10)',
            '--header-bg': 'rgba(232,234,237,0.96)',
            '--sidebar-bg': 'rgba(244,245,247,0.97)',
            '--overlay-bg': 'rgba(232,234,237,0.97)',
            '--scrollbar-thumb': 'rgba(0,0,0,0.12)',
            '--scrollbar-thumb-hover': 'rgba(0,0,0,0.25)',
        },
    },
    darkroom: {
        name: 'darkroom',
        label: 'Darkroom',
        group: 'Vintage Cameras',
        colors: {
            '--bg-primary': '#0a0000',
            '--bg-secondary': 'rgba(200,30,30,0.08)',
            '--bg-tertiary': 'rgba(200,30,30,0.12)',
            '--bg-hover': 'rgba(200,30,30,0.16)',
            '--bg-solid': '#120000',
            '--text-primary': '#FF9090',
            '--text-secondary': '#CC6060',
            '--text-muted': '#803030',
            '--text-on-accent': '#0a0000',
            '--accent': '#CC2020',
            '--accent-hover': '#FF3333',
            '--accent-glow': 'rgba(200,30,30,0.25)',
            '--accent-subtle': 'rgba(200,30,30,0.10)',
            '--error': '#FF6666',
            '--error-bg': 'rgba(255,102,102,0.10)',
            '--success': '#55AA55',
            '--success-bg': 'rgba(85,170,85,0.10)',
            '--warning': '#DDAA00',
            '--warning-bg': 'rgba(221,170,0,0.10)',
            '--border': 'rgba(200,30,30,0.12)',
            '--border-hover': 'rgba(200,30,30,0.22)',
            '--border-accent': 'rgba(200,30,30,0.38)',
            '--glass-bg': 'rgba(200,30,30,0.04)',
            '--glass-border': 'rgba(200,30,30,0.10)',
            '--shadow-glow': '0 0 24px rgba(200,30,30,0.15)',
            '--header-bg': 'rgba(10,0,0,0.92)',
            '--sidebar-bg': 'rgba(10,0,0,0.75)',
            '--overlay-bg': 'rgba(10,0,0,0.95)',
            '--scrollbar-thumb': 'rgba(200,30,30,0.12)',
            '--scrollbar-thumb-hover': 'rgba(200,30,30,0.25)',
        },
    },
    chrome_leather: {
        name: 'chrome_leather',
        label: 'Chrome & Leather',
        group: 'Vintage Cameras',
        colors: {
            '--bg-primary': '#f5f0eb',
            '--bg-secondary': '#faf7f4',
            '--bg-tertiary': '#ede5dd',
            '--bg-hover': 'rgba(139,90,43,0.08)',
            '--bg-solid': '#e8dfd6',
            '--text-primary': '#2c1810',
            '--text-secondary': '#5c3d28',
            '--text-muted': '#9c8068',
            '--text-on-accent': '#ffffff',
            '--accent': '#8B5A2B',
            '--accent-hover': '#A0693A',
            '--accent-glow': 'rgba(139,90,43,0.15)',
            '--accent-subtle': 'rgba(139,90,43,0.08)',
            '--error': '#c0392b',
            '--error-bg': 'rgba(192,57,43,0.08)',
            '--success': '#27ae60',
            '--success-bg': 'rgba(39,174,96,0.08)',
            '--warning': '#d4a017',
            '--warning-bg': 'rgba(212,160,23,0.08)',
            '--border': 'rgba(44,24,16,0.10)',
            '--border-hover': 'rgba(44,24,16,0.18)',
            '--border-accent': 'rgba(139,90,43,0.35)',
            '--glass-bg': 'rgba(44,24,16,0.02)',
            '--glass-border': 'rgba(44,24,16,0.06)',
            '--shadow-glow': '0 1px 3px rgba(44,24,16,0.10)',
            '--header-bg': 'rgba(245,240,235,0.96)',
            '--sidebar-bg': 'rgba(250,247,244,0.97)',
            '--overlay-bg': 'rgba(245,240,235,0.97)',
            '--scrollbar-thumb': 'rgba(44,24,16,0.12)',
            '--scrollbar-thumb-hover': 'rgba(44,24,16,0.25)',
        },
    },
    kodachrome: {
        name: 'kodachrome',
        label: 'Kodachrome',
        group: 'Vintage Cameras',
        colors: {
            '--bg-primary': '#faf4e8',
            '--bg-secondary': '#fefbf4',
            '--bg-tertiary': '#f0e4d0',
            '--bg-hover': 'rgba(200,72,32,0.08)',
            '--bg-solid': '#ecdcc4',
            '--text-primary': '#2a1c10',
            '--text-secondary': '#5c3820',
            '--text-muted': '#9a7858',
            '--text-on-accent': '#ffffff',
            '--accent': '#c84820',
            '--accent-hover': '#e05828',
            '--accent-glow': 'rgba(200,72,32,0.18)',
            '--accent-subtle': 'rgba(200,72,32,0.08)',
            '--error': '#c02020',
            '--error-bg': 'rgba(192,32,32,0.08)',
            '--success': '#2a8a40',
            '--success-bg': 'rgba(42,138,64,0.08)',
            '--warning': '#c88020',
            '--warning-bg': 'rgba(200,128,32,0.08)',
            '--border': 'rgba(42,28,16,0.10)',
            '--border-hover': 'rgba(42,28,16,0.18)',
            '--border-accent': 'rgba(200,72,32,0.35)',
            '--glass-bg': 'rgba(42,28,16,0.02)',
            '--glass-border': 'rgba(42,28,16,0.06)',
            '--shadow-glow': '0 1px 3px rgba(42,28,16,0.10)',
            '--header-bg': 'rgba(250,244,232,0.96)',
            '--sidebar-bg': 'rgba(254,251,244,0.97)',
            '--overlay-bg': 'rgba(250,244,232,0.97)',
            '--scrollbar-thumb': 'rgba(42,28,16,0.12)',
            '--scrollbar-thumb-hover': 'rgba(42,28,16,0.25)',
        },
    },
    film_noir: {
        name: 'film_noir',
        label: 'Film Noir',
        group: 'Vintage Cameras',
        colors: {
            '--bg-primary': '#0a0a0a',
            '--bg-secondary': 'rgba(192,192,192,0.06)',
            '--bg-tertiary': 'rgba(192,192,192,0.10)',
            '--bg-hover': 'rgba(192,192,192,0.14)',
            '--bg-solid': '#141414',
            '--text-primary': '#e8e8e8',
            '--text-secondary': '#a8a8a8',
            '--text-muted': '#606060',
            '--text-on-accent': '#0a0a0a',
            '--accent': '#c0c0c0',
            '--accent-hover': '#e0e0e0',
            '--accent-glow': 'rgba(192,192,192,0.18)',
            '--accent-subtle': 'rgba(192,192,192,0.08)',
            '--error': '#e04040',
            '--error-bg': 'rgba(224,64,64,0.10)',
            '--success': '#60b060',
            '--success-bg': 'rgba(96,176,96,0.10)',
            '--warning': '#d0a030',
            '--warning-bg': 'rgba(208,160,48,0.10)',
            '--border': 'rgba(192,192,192,0.10)',
            '--border-hover': 'rgba(192,192,192,0.18)',
            '--border-accent': 'rgba(192,192,192,0.35)',
            '--glass-bg': 'rgba(192,192,192,0.03)',
            '--glass-border': 'rgba(192,192,192,0.08)',
            '--shadow-glow': '0 0 24px rgba(192,192,192,0.08)',
            '--header-bg': 'rgba(10,10,10,0.95)',
            '--sidebar-bg': 'rgba(20,20,20,0.95)',
            '--overlay-bg': 'rgba(10,10,10,0.97)',
            '--scrollbar-thumb': 'rgba(192,192,192,0.10)',
            '--scrollbar-thumb-hover': 'rgba(192,192,192,0.22)',
        },
    },
    cyanotype: {
        name: 'cyanotype',
        label: 'Cyanotype',
        group: 'Vintage Cameras',
        colors: {
            '--bg-primary': '#f4f0e8',
            '--bg-secondary': '#faf8f2',
            '--bg-tertiary': '#e8e0d4',
            '--bg-hover': 'rgba(20,60,110,0.08)',
            '--bg-solid': '#dcd4c6',
            '--text-primary': '#0a2040',
            '--text-secondary': '#1a3860',
            '--text-muted': '#5878a0',
            '--text-on-accent': '#f4f0e8',
            '--accent': '#143c6e',
            '--accent-hover': '#1a5090',
            '--accent-glow': 'rgba(20,60,110,0.18)',
            '--accent-subtle': 'rgba(20,60,110,0.08)',
            '--error': '#a03020',
            '--error-bg': 'rgba(160,48,32,0.08)',
            '--success': '#2a7040',
            '--success-bg': 'rgba(42,112,64,0.08)',
            '--warning': '#a07020',
            '--warning-bg': 'rgba(160,112,32,0.08)',
            '--border': 'rgba(10,32,64,0.10)',
            '--border-hover': 'rgba(10,32,64,0.18)',
            '--border-accent': 'rgba(20,60,110,0.35)',
            '--glass-bg': 'rgba(10,32,64,0.02)',
            '--glass-border': 'rgba(10,32,64,0.06)',
            '--shadow-glow': '0 1px 3px rgba(10,32,64,0.10)',
            '--header-bg': 'rgba(244,240,232,0.96)',
            '--sidebar-bg': 'rgba(250,248,242,0.97)',
            '--overlay-bg': 'rgba(244,240,232,0.97)',
            '--scrollbar-thumb': 'rgba(10,32,64,0.12)',
            '--scrollbar-thumb-hover': 'rgba(10,32,64,0.25)',
        },
    },
    midnight_dial: {
        name: 'midnight_dial',
        label: 'Midnight Dial',
        group: 'Watches',
        colors: {
            '--bg-primary': '#0a0e1a',
            '--bg-secondary': 'rgba(100,140,220,0.08)',
            '--bg-tertiary': 'rgba(100,140,220,0.12)',
            '--bg-hover': 'rgba(100,140,220,0.16)',
            '--bg-solid': '#0f1428',
            '--text-primary': '#c8d6f0',
            '--text-secondary': '#8898c0',
            '--text-muted': '#506090',
            '--text-on-accent': '#0a0e1a',
            '--accent': '#7090d0',
            '--accent-hover': '#90b0f0',
            '--accent-glow': 'rgba(100,140,220,0.20)',
            '--accent-subtle': 'rgba(100,140,220,0.08)',
            '--error': '#ef4444',
            '--error-bg': 'rgba(239,68,68,0.10)',
            '--success': '#22c55e',
            '--success-bg': 'rgba(34,197,94,0.10)',
            '--warning': '#f59e0b',
            '--warning-bg': 'rgba(245,158,11,0.10)',
            '--border': 'rgba(100,140,220,0.10)',
            '--border-hover': 'rgba(100,140,220,0.18)',
            '--border-accent': 'rgba(100,140,220,0.35)',
            '--glass-bg': 'rgba(100,140,220,0.04)',
            '--glass-border': 'rgba(100,140,220,0.08)',
            '--shadow-glow': '0 0 24px rgba(100,140,220,0.12)',
            '--header-bg': 'rgba(10,14,26,0.95)',
            '--sidebar-bg': 'rgba(15,20,40,0.95)',
            '--overlay-bg': 'rgba(10,14,26,0.97)',
            '--scrollbar-thumb': 'rgba(100,140,220,0.10)',
            '--scrollbar-thumb-hover': 'rgba(100,140,220,0.20)',
        },
    },
    guilloche: {
        name: 'guilloche',
        label: 'Guilloché',
        group: 'Watches',
        colors: {
            '--bg-primary': '#f9f5ef',
            '--bg-secondary': '#fdfaf6',
            '--bg-tertiary': '#f0e8dc',
            '--bg-hover': 'rgba(180,145,80,0.08)',
            '--bg-solid': '#ece2d2',
            '--text-primary': '#2a2015',
            '--text-secondary': '#5c4d38',
            '--text-muted': '#9a8a70',
            '--text-on-accent': '#ffffff',
            '--accent': '#B49150',
            '--accent-hover': '#C8A060',
            '--accent-glow': 'rgba(180,145,80,0.18)',
            '--accent-subtle': 'rgba(180,145,80,0.08)',
            '--error': '#b91c1c',
            '--error-bg': 'rgba(185,28,28,0.08)',
            '--success': '#15803d',
            '--success-bg': 'rgba(21,128,61,0.08)',
            '--warning': '#b45309',
            '--warning-bg': 'rgba(180,83,9,0.08)',
            '--border': 'rgba(42,32,21,0.10)',
            '--border-hover': 'rgba(42,32,21,0.18)',
            '--border-accent': 'rgba(180,145,80,0.35)',
            '--glass-bg': 'rgba(42,32,21,0.02)',
            '--glass-border': 'rgba(42,32,21,0.06)',
            '--shadow-glow': '0 1px 3px rgba(42,32,21,0.10)',
            '--header-bg': 'rgba(249,245,239,0.96)',
            '--sidebar-bg': 'rgba(253,250,246,0.97)',
            '--overlay-bg': 'rgba(249,245,239,0.97)',
            '--scrollbar-thumb': 'rgba(42,32,21,0.12)',
            '--scrollbar-thumb-hover': 'rgba(42,32,21,0.25)',
        },
    },
    patina: {
        name: 'patina',
        label: 'Patina',
        group: 'Watches',
        colors: {
            '--bg-primary': '#0e1210',
            '--bg-secondary': 'rgba(120,160,100,0.08)',
            '--bg-tertiary': 'rgba(120,160,100,0.12)',
            '--bg-hover': 'rgba(120,160,100,0.16)',
            '--bg-solid': '#141a16',
            '--text-primary': '#c8d8c0',
            '--text-secondary': '#90a888',
            '--text-muted': '#587050',
            '--text-on-accent': '#0e1210',
            '--accent': '#88a870',
            '--accent-hover': '#a0c888',
            '--accent-glow': 'rgba(136,168,112,0.20)',
            '--accent-subtle': 'rgba(136,168,112,0.08)',
            '--error': '#d04040',
            '--error-bg': 'rgba(208,64,64,0.10)',
            '--success': '#50a858',
            '--success-bg': 'rgba(80,168,88,0.10)',
            '--warning': '#c8a030',
            '--warning-bg': 'rgba(200,160,48,0.10)',
            '--border': 'rgba(120,160,100,0.10)',
            '--border-hover': 'rgba(120,160,100,0.18)',
            '--border-accent': 'rgba(136,168,112,0.35)',
            '--glass-bg': 'rgba(120,160,100,0.04)',
            '--glass-border': 'rgba(120,160,100,0.08)',
            '--shadow-glow': '0 0 24px rgba(136,168,112,0.12)',
            '--header-bg': 'rgba(14,18,16,0.95)',
            '--sidebar-bg': 'rgba(20,26,22,0.95)',
            '--overlay-bg': 'rgba(14,18,16,0.97)',
            '--scrollbar-thumb': 'rgba(120,160,100,0.10)',
            '--scrollbar-thumb-hover': 'rgba(120,160,100,0.22)',
        },
    },
    rose_gold: {
        name: 'rose_gold',
        label: 'Rosé Gold',
        group: 'Watches',
        colors: {
            '--bg-primary': '#faf5f2',
            '--bg-secondary': '#fefbf9',
            '--bg-tertiary': '#f2e8e2',
            '--bg-hover': 'rgba(184,120,100,0.08)',
            '--bg-solid': '#ecddd4',
            '--text-primary': '#2a1818',
            '--text-secondary': '#5c3838',
            '--text-muted': '#9a7878',
            '--text-on-accent': '#ffffff',
            '--accent': '#b87868',
            '--accent-hover': '#d09080',
            '--accent-glow': 'rgba(184,120,104,0.18)',
            '--accent-subtle': 'rgba(184,120,104,0.08)',
            '--error': '#b82020',
            '--error-bg': 'rgba(184,32,32,0.08)',
            '--success': '#1a8040',
            '--success-bg': 'rgba(26,128,64,0.08)',
            '--warning': '#b08020',
            '--warning-bg': 'rgba(176,128,32,0.08)',
            '--border': 'rgba(42,24,24,0.10)',
            '--border-hover': 'rgba(42,24,24,0.18)',
            '--border-accent': 'rgba(184,120,104,0.35)',
            '--glass-bg': 'rgba(42,24,24,0.02)',
            '--glass-border': 'rgba(42,24,24,0.06)',
            '--shadow-glow': '0 1px 3px rgba(42,24,24,0.10)',
            '--header-bg': 'rgba(250,245,242,0.96)',
            '--sidebar-bg': 'rgba(254,251,249,0.97)',
            '--overlay-bg': 'rgba(250,245,242,0.97)',
            '--scrollbar-thumb': 'rgba(42,24,24,0.12)',
            '--scrollbar-thumb-hover': 'rgba(42,24,24,0.25)',
        },
    },
    lume: {
        name: 'lume',
        label: 'Lume',
        group: 'Watches',
        colors: {
            '--bg-primary': '#060a0c',
            '--bg-secondary': 'rgba(60,200,180,0.06)',
            '--bg-tertiary': 'rgba(60,200,180,0.10)',
            '--bg-hover': 'rgba(60,200,180,0.14)',
            '--bg-solid': '#0a1014',
            '--text-primary': '#b0e8d8',
            '--text-secondary': '#70b8a0',
            '--text-muted': '#408068',
            '--text-on-accent': '#060a0c',
            '--accent': '#3cc8b4',
            '--accent-hover': '#50e0cc',
            '--accent-glow': 'rgba(60,200,180,0.25)',
            '--accent-subtle': 'rgba(60,200,180,0.08)',
            '--error': '#e04848',
            '--error-bg': 'rgba(224,72,72,0.10)',
            '--success': '#40c060',
            '--success-bg': 'rgba(64,192,96,0.10)',
            '--warning': '#d0a830',
            '--warning-bg': 'rgba(208,168,48,0.10)',
            '--border': 'rgba(60,200,180,0.10)',
            '--border-hover': 'rgba(60,200,180,0.18)',
            '--border-accent': 'rgba(60,200,180,0.35)',
            '--glass-bg': 'rgba(60,200,180,0.03)',
            '--glass-border': 'rgba(60,200,180,0.08)',
            '--shadow-glow': '0 0 24px rgba(60,200,180,0.15)',
            '--header-bg': 'rgba(6,10,12,0.95)',
            '--sidebar-bg': 'rgba(10,16,20,0.95)',
            '--overlay-bg': 'rgba(6,10,12,0.97)',
            '--scrollbar-thumb': 'rgba(60,200,180,0.10)',
            '--scrollbar-thumb-hover': 'rgba(60,200,180,0.22)',
        },
    },
    modern_dark: {
        name: 'modern_dark',
        label: 'Modern Dark',
        group: 'General',
        colors: {
            '--bg-primary': '#0f1419',
            '--bg-secondary': '#1a2332',
            '--bg-tertiary': '#1f2937',
            '--bg-hover': 'rgba(59,130,246,0.08)',
            '--bg-solid': '#151d2b',
            '--text-primary': '#e4e8ee',
            '--text-secondary': '#9ca3af',
            '--text-muted': '#5b6378',
            '--text-on-accent': '#ffffff',
            '--accent': '#60a5fa',
            '--accent-hover': '#93c5fd',
            '--accent-glow': 'rgba(59,130,246,0.15)',
            '--accent-subtle': 'rgba(59,130,246,0.08)',
            '--error': '#ef4444',
            '--error-bg': 'rgba(239,68,68,0.10)',
            '--success': '#22c55e',
            '--success-bg': 'rgba(34,197,94,0.10)',
            '--warning': '#f59e0b',
            '--warning-bg': 'rgba(245,158,11,0.10)',
            '--border': 'rgba(255,255,255,0.08)',
            '--border-hover': 'rgba(255,255,255,0.14)',
            '--border-accent': 'rgba(59,130,246,0.35)',
            '--glass-bg': 'rgba(255,255,255,0.03)',
            '--glass-border': 'rgba(255,255,255,0.06)',
            '--shadow-glow': '0 1px 3px rgba(0,0,0,0.30)',
            '--header-bg': 'rgba(15,20,25,0.95)',
            '--sidebar-bg': 'rgba(21,29,43,0.95)',
            '--overlay-bg': 'rgba(15,20,25,0.95)',
            '--scrollbar-thumb': 'rgba(255,255,255,0.10)',
            '--scrollbar-thumb-hover': 'rgba(255,255,255,0.20)',
        },
    },
    modern_light: {
        name: 'modern_light',
        label: 'Modern Light',
        group: 'General',
        colors: {
            '--bg-primary': '#f8f9fb',
            '--bg-secondary': '#ffffff',
            '--bg-tertiary': '#f1f5f9',
            '--bg-hover': 'rgba(59,130,246,0.06)',
            '--bg-solid': '#eef2f7',
            '--text-primary': '#111827',
            '--text-secondary': '#4b5563',
            '--text-muted': '#9ca3af',
            '--text-on-accent': '#ffffff',
            '--accent': '#3b82f6',
            '--accent-hover': '#2563eb',
            '--accent-glow': 'rgba(59,130,246,0.12)',
            '--accent-subtle': 'rgba(59,130,246,0.06)',
            '--error': '#dc2626',
            '--error-bg': 'rgba(220,38,38,0.08)',
            '--success': '#16a34a',
            '--success-bg': 'rgba(22,163,74,0.08)',
            '--warning': '#d97706',
            '--warning-bg': 'rgba(217,119,6,0.08)',
            '--border': 'rgba(0,0,0,0.08)',
            '--border-hover': 'rgba(0,0,0,0.14)',
            '--border-accent': 'rgba(59,130,246,0.35)',
            '--glass-bg': 'rgba(0,0,0,0.02)',
            '--glass-border': 'rgba(0,0,0,0.06)',
            '--shadow-glow': '0 1px 3px rgba(0,0,0,0.08)',
            '--header-bg': 'rgba(248,249,251,0.95)',
            '--sidebar-bg': 'rgba(255,255,255,0.97)',
            '--overlay-bg': 'rgba(248,249,251,0.97)',
            '--scrollbar-thumb': 'rgba(0,0,0,0.12)',
            '--scrollbar-thumb-hover': 'rgba(0,0,0,0.25)',
        },
    },
    vivid: {
        name: 'vivid',
        label: 'Vivid',
        group: 'General',
        colors: {
            '--bg-primary': '#faf8f5',
            '--bg-secondary': '#ffffff',
            '--bg-tertiary': '#f5f0eb',
            '--bg-hover': 'rgba(249,115,22,0.06)',
            '--bg-solid': '#f0ebe5',
            '--text-primary': '#1c1917',
            '--text-secondary': '#57534e',
            '--text-muted': '#a8a29e',
            '--text-on-accent': '#ffffff',
            '--accent': '#f97316',
            '--accent-hover': '#ea580c',
            '--accent-glow': 'rgba(249,115,22,0.15)',
            '--accent-subtle': 'rgba(249,115,22,0.08)',
            '--error': '#dc2626',
            '--error-bg': 'rgba(220,38,38,0.08)',
            '--success': '#16a34a',
            '--success-bg': 'rgba(22,163,74,0.08)',
            '--warning': '#d97706',
            '--warning-bg': 'rgba(217,119,6,0.08)',
            '--border': 'rgba(28,25,23,0.08)',
            '--border-hover': 'rgba(28,25,23,0.15)',
            '--border-accent': 'rgba(249,115,22,0.35)',
            '--glass-bg': 'rgba(28,25,23,0.02)',
            '--glass-border': 'rgba(28,25,23,0.06)',
            '--shadow-glow': '0 1px 4px rgba(28,25,23,0.08)',
            '--header-bg': 'rgba(250,248,245,0.97)',
            '--sidebar-bg': 'rgba(255,255,255,0.98)',
            '--overlay-bg': 'rgba(250,248,245,0.97)',
            '--scrollbar-thumb': 'rgba(28,25,23,0.12)',
            '--scrollbar-thumb-hover': 'rgba(28,25,23,0.25)',
        },
    },
};
//# sourceMappingURL=themes.js.map